var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-favicon"},[_c('app-filepicker',{attrs:{"label":"Icon wählen","data-source":"deha.user.misc.favicon","accept":".jpg,.png,.gif"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }